import type * as Sentry from "@sentry/react";

export const HTTP_CLIENT_MECHANISM_PREFIX = "auto.http.client.";
export const HTTP_CLIENT_ERROR_FINGERPRINT_PREFIX = "http-client-error";
export const ID_PLACEHOLDER = ":id";
const NUMERIC_SEGMENT_PATTERN = /^\d+$/;
const UUID_SEGMENT_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function normalizePathSegment(segment: string): string {
  if (NUMERIC_SEGMENT_PATTERN.test(segment) || UUID_SEGMENT_PATTERN.test(segment)) {
    return ID_PLACEHOLDER;
  }
  return segment;
}

export function normalizeHttpErrorPath(url: string): string | undefined {
  let pathname: string;

  try {
    pathname = new URL(url, window.location.origin).pathname;
  } catch {
    return undefined;
  }

  const segments = pathname.split("/").filter(Boolean).map(normalizePathSegment);
  return `/${segments.join("/")}`;
}

export function isHttpClientErrorEvent(event: Sentry.ErrorEvent): boolean {
  const mechanismType = event.exception?.values?.[0]?.mechanism?.type;
  return typeof mechanismType === "string" && mechanismType.startsWith(HTTP_CLIENT_MECHANISM_PREFIX);
}

export function getHttpClientErrorFingerprint(event: Sentry.ErrorEvent): string[] | undefined {
  if (!isHttpClientErrorEvent(event)) {
    return undefined;
  }

  const method = event.request?.method;
  const url = event.request?.url;
  const status = event.contexts?.response?.status_code;

  if (!method || !url || status === undefined) {
    return undefined;
  }

  const normalizedPath = normalizeHttpErrorPath(url);
  if (!normalizedPath) {
    return undefined;
  }

  return [HTTP_CLIENT_ERROR_FINGERPRINT_PREFIX, method.toUpperCase(), normalizedPath, String(status)];
}
